//////画像切り替え
$(function () {
  var width = $(window).width();
  if( width < 900 ){
    $("img").each(function(){
      $(this).attr("src", $(this).attr("src").replace("_pc","_sp"));
    })
  }
});
//////ナビゲーション
$(function(){
  $('.menu_trigger').on('click',function(){
    $(this).toggleClass('active');
    $('.header_nav_contents').slideToggle();
  });
});
$(function() {
    $('.menu_trigger').click(function(){
        $('.header_contents').toggleClass('active');
    });
});
$('.header_nav_contents a').on('click', function(){
        if (window.innerWidth <= 900) {
            $('.menu_trigger').click();
        }
    });	

$(window).on('resize', function() {
	if( 'none' == $('.header_nav_contents').css('display') ){
		$('.header_nav_contents').attr('style','');
	}
});

//////スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 1000 ;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});
//////スムーススクロールIE
if(navigator.userAgent.match(/(msie|MSIE) 10/i) || navigator.userAgent.match(/(T|t)rident\/7\./) || navigator.userAgent.match(/Edge\/\d+\.\d+/)) {
   $('body').on("mousewheel", function () {
     if(event.preventDefault){
        event.preventDefault();
     }else{
        event.returnValue=false;
     }
    var wd = event.wheelDelta;
    var csp = window.pageYOffset;
    window.scrollTo(0, csp - wd);
  });
}

//////リンク
$(document).ready(function(){
  $(".link").click(function(){
    if($(this).find("a").attr("target")=="_blank"){
      window.open($(this).find("a").attr("href"), '_blank');
    }else{
      window.location=$(this).find("a").attr("href");
    }
  return false;
  });
})


//////サイドバナー
$(window).on("scroll", function() {
    scrollHeight = $(document).height();
    scrollPosition = $(window).height() + $(window).scrollTop();
    footHeight = $("footer").innerHeight();
    if ( scrollHeight - scrollPosition  <= footHeight ) {
      $(".link_btn").css({
        "position":"absolute",
        "bottom": footHeight + 10
      });
    } else {
      $(".link_btn").css({
        "position":"fixed",
      });
    }
  }); 
  $(function(){
    $(".link_btn").on("click", function() {
      $(this).toggleClass("link_btn_active");
    });
  });

//////ページトップ
$(function () {
  var topBtn = $('#page_top');
  topBtn.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 650) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });
});
//////more
$(function(){
	$(".more01").on("click", function() {
		$(this).toggleClass("on_click");
		$(".ac_hide01").slideToggle(500);
	});
}); 
$(function(){
	$(".more02").on("click", function() {
		$(this).toggleClass("on_click");
		$(".ac_hide02").slideToggle(500);
	});
}); 
$(function(){
	$(".more03").on("click", function() {
		$(this).toggleClass("on_click");
		$(".ac_hide03").slideToggle(500);
	});
});
$(function(){
	$(".more04").on("click", function() {
		$(this).toggleClass("on_click");
		$(".ac_hide04").slideToggle(500);
	});
});


$(function () {
  $(".slider").slick({
    speed: 1000,
    autoplay: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '30%',
    responsive: [{
      breakpoint: 900,
      settings: {
      centerPadding: '20%',
      }
    }, {
      breakpoint: 640,
      settings: {
      centerPadding: '10%',
      }
    }]
  });
});